export const Letter = (props: object) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox={`0 0 24 24`}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4418_7572)">
        <path
          d="M16.5 20.75H7.5C6.75 20.75 6.2 20.72 5.73 20.65C2.41 20.29 1.75 18.3 1.75 15V9C1.75 5.7 2.41 3.71 5.76 3.34C6.2 3.28 6.75 3.25 7.5 3.25H16.5C17.25 3.25 17.8 3.28 18.27 3.35C21.59 3.71 22.25 5.7 22.25 9V15C22.25 18.3 21.59 20.29 18.24 20.66C17.8 20.72 17.25 20.75 16.5 20.75ZM7.5 4.75C6.82 4.75 6.34 4.78 5.95 4.83C3.92 5.06 3.25 5.69 3.25 9V15C3.25 18.31 3.92 18.94 5.92 19.17C6.34 19.23 6.82 19.25 7.5 19.25H16.5C17.18 19.25 17.66 19.22 18.05 19.17C20.08 18.95 20.75 18.31 20.75 15V9C20.75 5.69 20.08 5.06 18.08 4.83C17.66 4.77 17.18 4.75 16.5 4.75H7.5Z"
          fill="white"
          style={{ fill: 'var(--fillg)' }}
        />
        <path
          d="M17 10.75H13.5C13.09 10.75 12.75 10.41 12.75 10C12.75 9.59 13.09 9.25 13.5 9.25H17C17.41 9.25 17.75 9.59 17.75 10C17.75 10.41 17.41 10.75 17 10.75Z"
          fill="white"
          style={{ fill: 'var(--fillg)' }}
        />
        <path
          d="M10.1001 11C9.5501 11 9.1001 10.55 9.1001 10C9.1001 9.45 9.5401 9 10.1001 9H10.1101C10.6601 9 11.1101 9.45 11.1101 10C11.1101 10.55 10.6601 11 10.1001 11Z"
          fill="white"
          style={{ fill: 'var(--fillg)' }}
        />
        <path
          d="M7.1001 11C6.5501 11 6.1001 10.55 6.1001 10C6.1001 9.45 6.5401 9 7.1001 9C7.6501 9 8.1001 9.45 8.1001 10C8.1001 10.55 7.6601 11 7.1001 11Z"
          fill="white"
          style={{ fill: 'var(--fillg)' }}
        />
        <path
          d="M17 16.25H7.02001C6.61001 16.25 6.26001 15.91 6.26001 15.5C6.26001 15.09 6.59001 14.75 7.00001 14.75H17C17.41 14.75 17.75 15.09 17.75 15.5C17.75 15.91 17.41 16.25 17 16.25Z"
          fill="white"
          style={{ fill: 'var(--fillg)' }}
        />
      </g>
      <defs>
        <clipPath id="clip0_4418_7572">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
